<template>
  <div class="isidore-footer">
    <div class="isidore-footer__main">
      <img
        class="isidore-footer__logo"
        src="/isidore-logo.svg"
        alt="ISIDORe - Integrated Services for Infectious Disease Outbreak Research"
      />
      <div class="isidore-footer__funding">
        <img
          class="isidore-footer__flag"
          src="/img/eu-flag.svg"
          alt="European Union"
        />
        <p class="isidore-footer__funding-text">
          ISIDORe II has received funding from the European Union's Horizon
          Europe research and innovation programme under grant agreement number
          101293306.
        </p>
      </div>
    </div>

    <div class="isidore-footer__colophon">
      <div>
        This database was created using the
        <a href="http://molgenis.org">MOLGENIS</a>&nbsp;
        <a href="http://github.com/molgenis/molgenis-emx2"> molgenis-emx2 </a>
        open source software (license:
        <a href="https://github.com/molgenis/molgenis-emx2/blob/master/LICENSE">
          LGPLv3
        </a>
        ).
      </div>
      <div>
        Please cite
        <a
          href="https://www.liebertpub.com/doi/10.1089/bio.2016.0088"
          target="_blank"
        >
          Holub et al. (2016)
        </a>
        for Directory use or
        <a href="https://www.ncbi.nlm.nih.gov/pubmed/30165396" target="_blank">
          Van der Velde et al. (2016)
        </a>
        for MOLGENIS use.
      </div>
      <div v-if="session?.manifest">
        Software version:
        <a
          :href="
            'https://github.com/molgenis/molgenis-emx2/releases/tag/' +
            session?.manifest.SpecificationVersion
          "
        >
          {{ session?.manifest.SpecificationVersion }}
        </a>
        .
        <span v-if="session?.manifest.DatabaseVersion">
          Database version: {{ session?.manifest.DatabaseVersion }}.
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  session?: any;
}>();
</script>

<style scoped>
/* Matches the "container-fluid p-3" gutter the vendor layout uses for <main>. */
.isidore-footer {
  padding-left: 1rem;
  padding-right: 1rem;
}

.isidore-footer__main {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.isidore-footer__logo {
  height: 3.5rem;
  width: auto;
  flex-shrink: 0;
}

.isidore-footer__funding {
  display: flex;
  align-items: center;
  gap: 1rem;
  /* No grow: the row is centred as a group rather than stretched full width. */
  flex: 0 1 auto;
  min-width: 0;
}

.isidore-footer__flag {
  height: 1.75rem;
  width: auto;
  flex-shrink: 0;
}

.isidore-footer__funding-text {
  margin: 0;
  max-width: 70ch;
  color: var(--app-secondary);
}

.isidore-footer__colophon {
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid var(--app-dark-surface-border);
  font-size: 0.8rem;
  color: #6c757d;
  text-align: center;
}

@media (max-width: 576px) {
  .isidore-footer__main {
    flex-direction: column;
    gap: 1.5rem;
  }

  .isidore-footer__funding {
    align-items: flex-start;
  }
}
</style>
